import React from 'react';
import styles from './PieChart.module.css';

interface PieChartProps {
  value: number; // 1-100 scale
  maxValue?: number;
  color?: string;
  size?: number;
}

export const PieChart: React.FC<PieChartProps> = ({
  value,
  maxValue = 100,
  color = '#20B2AA', // Videntis cyan color
  size = 60
}) => {
  // Convert value to percentage (0-100)
  const percentage = Math.min(Math.max((value / maxValue) * 100, 0), 100);
  
  // Calculate stroke-dasharray for the circle
  // Circumference = 2 * π * radius
  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  
  return (
    <div className={styles.pieChartContainer} style={{ width: size, height: size }}>
      <svg width={size} height={size} className={styles.pieChartSvg}>
        {/* Background circle - only show if not 100% */}
        {percentage < 100 && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="#e0e0e0"
            strokeWidth="4"
          />
        )}
        {/* Progress circle */}
        {percentage === 100 ? (
          // For 100%, draw a complete circle without dasharray
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="4"
            className={styles.progressCircle}
          />
        ) : percentage > 0 ? (
          // For partial progress, use dasharray
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="4"
            strokeDasharray={`${(percentage / 100) * circumference} ${circumference}`}
            strokeDashoffset={circumference / 4} // Start from top
            strokeLinecap="round"
            className={styles.progressCircle}
          />
        ) : null}
      </svg>
      <div className={styles.pieChartText}>
        <span className={styles.percentage}>{Math.round(percentage)}%</span>
      </div>
    </div>
  );
};